
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

import myCaptcha from 'vue-captcha';
import {appName} from '@/env';
import {readCurrentPrinterLog} from '@/store/main/getters';
import {dispatchGetPrinterLogsValidation} from '@/store/main/actions';

import {fromTimestamp, rules, toTimestamp} from '@/utils';

@Component({
  components: {
    'my-captcha': myCaptcha,
  },
})
export default class SignValidation extends Vue {

  private btndis: boolean = true;
  private appName: string = appName;
  private authorizationCode: string = '';



  private get headers() {
    return [
      {
        text: 'Código de autorização',
        align: 'start',
        value: 'authorization_code',
      },
      {text: 'Assinado por', value: 'created_by_user.fullname'},
      {text: 'Tipo de Conselho', value: 'created_by_user.council_type'},
      {text: 'Número do Conselho', value: 'created_by_user.professional_council'},
      {text: 'Data do registro', value: 'created_at'},
    ];
  }

  private get currentPrinterLog() {
    return [readCurrentPrinterLog(this.$store)];
  }

  public async mounted() {
    // @ts-ignore
    this.authorizationCode = this.$route.query?.authorization_code;
  }

  private async checkDocumentValidation() {
    await dispatchGetPrinterLogsValidation(this.$store, this.authorizationCode);
  }

  private captchaBtn() {
    this.btndis = false;
    this.checkDocumentValidation();
  }

  private toDateString(val) {
    return fromTimestamp(val?.created_at);
  }
}
